const ferries = {
  ferry: "العبارة", // translated 
  ferries: "العبارات", // translated 
  selectOriginPort: "حدد المنفذ الأصلي", // translated 
  selectDestPort: "حدد ميناء الوجهة", // translated 
  continue: "يكمل", // translated 
  viewTimetables: "عرض الجداول الزمنية", // translated 
  operator: "المشغل أو العامل", // translated 
  cabin: "الطائرة", // translated 
  cabins: "كبائن", // translated 
  place: "مكان", // translated 
  places: "أماكن", // translated 
  seat: "مقعد", // translated 
  seats: "مقاعد", // translated 
  seating: "الجلوس", // translated 
  deckSpace: "مساحة سطح السفينة", // translated 
  compulsory: "إلزامي", // translated 
  departure: "رحيل", // translated 
  total: "المجموع", // translated 
  back: "خلف", // translated 
  next: "التالي", // translated 
  duration: "مدة", // translated 
  return: "يعود", // translated 
  prebook: "الحجز المسبق", // translated 
  travelInfo: "معلومات السفر", // translated 
  book: "كتاب", // translated 
  adults: "الكبار", // translated 
  child: "طفل", // translated 
  seniors: "كبار السن", // translated 
  senior: "كبير", // translated 
  to: "ل", // translated 
  passenger: "راكب", // translated 
  details: "تفاصيل", // translated 
  currencyForTickets: "العملة لهذه التذاكر ستكون", // translated 
  seatsError: "عدد الركاب لا يساوي السعة.", // translated 
  title: "عنوان", // translated 
  firstName: "الاسم الأول", // translated 
  lastName: "اسم العائلة", // translated 
  email: "بريد إلكتروني", // translated 
  phone: "هاتف", // translated 
  dateOfBirth: "تاريخ الميلاد", // translated 
  placeOfBirth: "مكان الميلاد", // translated 
  groupLeader: "قائد المجموعة", // translated 
  isRequired: "مطلوب", // translated 
  charactersOnly: "الشخصيات فقط", // translated 
  latinCharactersAndSpacesOnly: "الأحرف اللاتينية والمسافات فقط", // translated 
  validEmail: "ليس بريدا إلكترونيا صالحا", // translated 
  atLeastOneAdult: "مطلوب شخص بالغ واحد على الأقل.", // translated 
  atLeastOneSenior: "مطلوب 1 كبير على الأقل.", // translated 
  toastAlert: "يرجى تصحيح جميع الأخطاء في النماذج أدناه.", // translated 
  backToFerriesList: "العودة إلى قائمة العبارات", // translated 
  bestPrice: "افضل سعر", // translated 
  fastest: "الأسرع", // translated 
  beforeDeparture: "قبل المغادرة", // translated 
  perPerson: "للشخص الواحد", // translated 
  notAvailableForOnlineBooking: "غير متاح للحجز عبر الإنترنت", // translated 
  hurryLimitedAvailability: "أسرع - بسرعة! توافر محدود", // translated 
  berth: "رصيف", // translated 
  berths: "الأرصفة", // translated 
  sumOfSelectionNotEqualToPersons:
    "مجموع اختيارك لا يساوي عدد الركاب", // translated 
  attemptToBook: "لقد حاولت حجز ما مجموعه", // translated 
  seatsWhenYouHave: "المقاعد عندما يكون لديك", // translated 
  passengersTravelling: "الركاب المسافرين", // translated 
  withReturn: "مع تذاكر العودة", // translated 
  pleaseCorrectYourSelection: "يرجى تصحيح اختيارك", // translated 
  pleaseSelectUpTo: "الرجاء تحديد ما يصل إلى", // translated 
  accommodationTypes: "أنواع الإقامة", // translated 
  selectionPrices: "أسعار الاختيار", // translated 
  yourCurrentTicket: "نوع التذكرة الحالي الخاص بك هو", // translated 
  upgradeTo: "ترقية الى", // translated 
  wouldYouLikeToUpgrade: "هل ترغب في ترقية نوع التذكرة الخاصة بك؟", // translated 
  backToTicketTypes: "العودة إلى أنواع التذاكر", // translated 
  originPort: "ميناء الأصل", // translated 
  destinationPort: "ميناء الوصول", // translated 
  outboundDate: "تاريخ الصادرة", // translated 
  inboundDate: "تاريخ الوارد", // translated 
  passengers: "ركاب", // translated 
  hasReturn: "لديه عودة", // translated 
  passportNumber: "رقم جواز السفر", // translated 
  passportExpiryDate: "وقت نفاذ صلاحيه جواز السفر", // translated 
  passportPlaceOfIssue: "مكان اصدار جواز السفر", // translated 
  passportStartDate: "تاريخ بدء جواز السفر", // translated 
  cityCode: "رمز المدينة", // translated 
};



export default ferries;
